// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"95627cc5","796":"4eeca5c9"}[chunkId] + ".chunk.js";
};